import axios from '@/plugins/axios'
import type {
  ApiResponse,
  Branch,
  Country,
  Mosque,
  QuranSection,
  QuranSectionLine
} from '@/types/global'
import { context } from '.'

export const fetchCountries = async () => {
  const { data } = await axios.post<ApiResponse<Country[]>>(
    `/api/${context}/api/${import.meta.env.VITE_API_VERSION}/fetch/country`,
    {
      jsonrpc: '2.0',
      params: {}
    }
  )
  return data.result
}

export const fetchBranches = async () => {
  const { data } = await axios.post<ApiResponse<Branch[]>>(
    `/api/${context}/api/${import.meta.env.VITE_API_VERSION}/fetch/branch`,
    {
      jsonrpc: '2.0',
      params: {
        filter: [['is_company_branch', '=', true]]
      }
    }
  )
  return data.result
}

export const fetchMosques = async (branchId: number) => {
  const { data } = await axios.post<ApiResponse<Mosque[]>>(
    `/api/${context}/api/${import.meta.env.VITE_API_VERSION}/fetch/mosque`,
    {
      jsonrpc: '2.0',
      params: {
        company_branch_id: branchId
      }
    }
  )
  return data.result
}

export const fetchQuranSections = async (branchId: number) => {
  const { data } = await axios.post<ApiResponse<QuranSection[]>>(
    `/api/${context}/api/${import.meta.env.VITE_API_VERSION}/fetch/quran_section`,
    {
      jsonrpc: '2.0',
      params: {
        company_branch_id: branchId
      }
    }
  )
  return data.result
}

export const fetchQuranSectionLines = async (secionId: number) => {
  const { data } = await axios.post<ApiResponse<QuranSectionLine[]>>(
    `/api/${context}/api/${import.meta.env.VITE_API_VERSION}/fetch/quran_section_line`,
    {
      jsonrpc: '2.0',
      params: {
        section_id: secionId
      }
    }
  )
  return data.result
}

export const educationTypes = [
  {
    label: 'مدارس تحفيظ',
    value: 'memorization'
  },
  {
    label: 'تعليم عام',
    value: 'general'
  },
  {
    label: 'اخرى',
    value: 'other'
  },
  {
    label: 'لا يوجد',
    value: 'none'
  }
]
